import { Suspense, lazy } from 'react'
import ErrorBoundary from '../ErrorBoundary'
const Spline = lazy(() => import('@splinetool/react-spline'))

export function SplineScene({ scene, className }) {
  return (
    // If the remote 3D scene fails to load or Spline throws (WebGL unavailable,
    // chunk load error, etc.), fall back to an empty placeholder instead of
    // letting it white-screen the whole page.
    <ErrorBoundary fallback={<div className={className} aria-hidden="true" />}>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <span className="loader"></span>
          </div>
        }
      >
        <Spline
          scene={scene}
          className={className}
        />
      </Suspense>
    </ErrorBoundary>
  )
}
